import {ValidationStatus, ValidationType} from './types';
import {BlindMapQuestion} from '@ael/core-api';

export class BlindMapQuestionValidator {
  public static isValid(item: BlindMapQuestion) {
    return this.validate(item).length === 0;
  }
  public static validate(item: BlindMapQuestion): ValidationStatus[] {
    const validations = [];

    if (!item.position) {
      validations.push({
        type: ValidationType.Error,
        message: 'Missing blind map question position.',
        item,
        itemName: item.title,
      });
    }

    return validations;
  }
}
